// The test payments line (JTP-27): while JTPay's app key is a test key, Pay, the result page and
// admin booking payments say no real money moves. Nothing renders for a live key, no JTPay
// settings, or a failed read.
//
// `testPayments` is for tests; without it the line reads the payments mode once per page load.
import React from 'react';
import { TEST_PAYMENTS_NOTE, fetchTestPayments } from '../lib/payments';
import { palette as COLORS, type, font } from '../design';

export function TestPaymentsNote({ testPayments, align = 'left', style }) {
  const given = typeof testPayments === 'boolean';
  const [read, setRead] = React.useState(false);

  React.useEffect(() => {
    if (given) return undefined;
    let current = true;
    fetchTestPayments().then((on) => { if (current) setRead(on); });
    return () => { current = false; };
  }, [given]);

  if (!(given ? testPayments : read)) return null;
  return (
    <p
      data-testid="test-payments-note"
      style={{ fontFamily: font.body, fontSize: type.caption, color: COLORS.driftwood, lineHeight: 1.5, margin: 0, textAlign: align, ...style }}
    >
      {TEST_PAYMENTS_NOTE}
    </p>
  );
}
